/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-tag-spacing */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-first-prop-new-line */
/* eslint-disable no-trailing-spaces */
import React from 'react';
import { Box, makeStyles, Theme } from '@material-ui/core';

type LogoNameStylesProps = {
  clickable: boolean;
};

const useStyles = makeStyles<Theme, LogoNameStylesProps>((theme: Theme) => ({
  root: ({ clickable }) => ({
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    '&:hover': {
      cursor: clickable ? 'pointer' : 'auto'
    }
  })
}));
interface LogoNameProps {
  onClick?: (e: React.MouseEvent<Element, MouseEvent>) => void
}
const LogoName: React.FC<LogoNameProps> = ({
  onClick
}) => {
  const styles = useStyles({ clickable: !!onClick });
  return (
    <Box className={styles.root} onClick={onClick}>
      <img className={styles.root} src='/CRLogo.jpg' height='28' alt='logo' />
    </Box>
  );
};

export default LogoName;

